module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Bold-9ba9259b101a8ba2dcde1d29c5b65514.svg";